<template>
  <div class="un-developed">
    <div class="content">
      <el-icon class="icon"><InfoFilled /></el-icon>
      <h1>功能开发中</h1>
      <p>该功能正在紧张开发中，敬请期待...</p>
      <el-button type="primary" @click="handleBack">返回首页</el-button>
    </div>
  </div>
</template>

<script>
import { InfoFilled } from '@element-plus/icons-vue';
import { useRouter } from 'vue-router';

export default {
  name: 'UnDeveloped',
  components: {
    InfoFilled
  },
  setup() {
    const router = useRouter();
    
    const handleBack = () => {
      router.push('/');
    };
    
    return {
      handleBack
    };
  }
};
</script>

<style scoped>
.un-developed {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  min-height: 400px;
  background-color: #f5f7fa;
}

.content {
  text-align: center;
  padding: 40px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.icon {
  font-size: 80px;
  color: #409eff;
  margin-bottom: 20px;
}

h1 {
  font-size: 24px;
  color: #333;
  margin-bottom: 10px;
}

p {
  font-size: 16px;
  color: #606266;
  margin-bottom: 30px;
}
</style>
